export default __webpack_public_path__ + "static/media/01.e04cf93f.png";